import { useState } from 'react'
import { AdminAlert, AdminButton, AdminInput } from '../AdminShared'
import { adminInvite } from '../../../services/admin'

export function InviteModal({ onClose }) {
  const [email, setEmail]   = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent]     = useState(false)
  const [error, setError]   = useState('')

  const send = async () => {
    if (!email.includes('@')) { setError('Enter a valid email.'); return }
    setError(''); setLoading(true)
    try {
      await adminInvite(email)
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 bg-on-background/60 flex items-center justify-center p-4" onClick={onClose}>
      <div className="w-full max-w-[460px] bg-surface border-4 border-on-background p-8 flex flex-col gap-5"
        style={{ boxShadow: '8px 8px 0px 0px var(--neo-border-color)' }}
        onClick={e => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <h2 className="font-extrabold text-[20px] uppercase tracking-tight">Invite Admin</h2>
            <p className="text-sm text-on-surface-variant mt-1">One-time link · expires 24 hours</p>
          </div>
          <button onClick={onClose} className="text-on-surface-variant hover:text-on-surface transition-colors ml-4">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        {error && <AdminAlert type="error" message={error} />}

        {sent ? (
          <>
            <AdminAlert type="success" message={`Invite sent to ${email}`} />
            <button onClick={onClose} className="w-full py-3 border-4 border-on-background font-bold uppercase tracking-widest text-sm bg-surface hover:bg-surface-container transition-colors">Done</button>
          </>
        ) : (
          <>
            <AdminInput id="invite-email" label="Colleague's Email" type="email" placeholder="colleague@chicago.io"
              value={email} onChange={e => setEmail(e.target.value)} error={error ? ' ' : ''} />
            <div className="bg-surface-container border-2 border-on-background/15 p-3 flex gap-3">
              <span className="material-symbols-outlined text-primary-container text-[18px] shrink-0 mt-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>info</span>
              <p className="text-[11px] text-on-surface-variant leading-relaxed">
                A secure invite link will be emailed directly to your colleague. It expires in 24 hours and is single-use.
              </p>
            </div>
            <AdminButton loading={loading} onClick={send}>
              <span className="material-symbols-outlined text-[18px]">send</span>
              Send Invite
            </AdminButton>
          </>
        )}
      </div>
    </div>
  )
}
